import { createFileRoute } from "@tanstack/react-router";

import { CaseDetailsV2Page } from "../../pages/cases/case-v2/CaseDetailsV2.page";

// An A/B route beside `/cases/$caseId`, which is not changed (LOA-1461).
export const Route = createFileRoute("/_protected/cases-version-2/$caseId")({
  component: CaseDetailsV2Page,
});
